<form [formGroup]="validationForm">
  <div class="speedoMeter">
    <div class="speedoMeter__title">Trip & Speedo Meter Validation</div>
    <div class="row no-gutters speedoMeter__content">
      <mat-card *ngIf="trip" class="speedoMeter__content__checkIn">
        <mat-card-title class="speedoMeter__content__checkIn__title"
          >Check In</mat-card-title
        >
        <mat-card-content
          class="row no-gutters speedoMeter__content__checkIn__content"
        >
          <img
            class="row no-gutters no-gutters speedoMeter__content__checkIn__content__img"
            alt=""
            [src]="trip.checkInUrl"
          />
          <div
            class="row no-gutters speedoMeter__content__checkIn__content__value"
          >
            <span
              *ngIf="!editCheckIn; else changeCheckIn"
              id="checkIn-value"
              class="speedoMeter__content__checkIn__content__value__show"
              >Check In Value:<span
                *ngIf="
                  trip.checkInValue != validationForm.value['correctedCheckIn']
                "
                class="strike"
              >
                {{ trip.checkInValue }}</span
              >
              {{ validationForm.value["correctedCheckIn"] }}</span
            >
            <ng-template
              class="speedoMeter__content__checkIn__content__value__template"
              #changeCheckIn
            >
              <span
                class="speedoMeter__content__checkIn__content__value__template__edit"
              >
                <mat-form-field
                  class="speedoMeter__content__checkIn__content__value__template__edit__form"
                >
                  <input
                    matInput
                    type="text"
                    id="edit-checkIn-value"
                    formControlName="correctedCheckIn"
                    class="speedoMeter__content__checkIn__content__value__template__edit__form__input"
                    [value]="validationForm.value['correctedCheckIn']"
                    autofocus
                    autocomplete="off"
                  />
                </mat-form-field>
              </span>
            </ng-template>
            <span
              class="row no-gutters speedoMeter__content__checkIn__content__value__image"
            >
              <i
                [ngClass]="editCheckIn == true ? 'fa fa-check' : 'fa fa-pencil'"
                class="speedoMeter__content__checkIn__content__value__image__icon"
                aria-hidden="true"
                (click)="isIconDisabled ? null : validateCheckIn()"
                [class.disabled]="isIconDisabled"
              ></i>
            </span>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card *ngIf="trip" class="speedoMeter__content__checkOut">
        <mat-card-title class="speedoMeter__content__checkOut__title"
          >Check Out</mat-card-title
        >
        <mat-card-content
          class="row no-gutters speedoMeter__content__checkOut__content"
        >
          <img
            class="row no-gutters no-gutters speedoMeter__content__checkOut__content__img"
            alt=""
            [src]="trip.checkOutUrl"
          />
          <div
            class="row no-gutters speedoMeter__content__checkOut__content__value"
          >
            <span
              *ngIf="!editCheckOut; else changeCheckOut"
              id="checkOut-value"
              class="speedoMeter__content__checkOut__content__value__show"
              >Check Out Value:
              <span
                *ngIf="
                  trip.checkOutValue !=
                  validationForm.value['correctedCheckOut']
                "
                class="strike"
              >
                {{ trip.checkOutValue }}</span
              >
              {{ validationForm.value["correctedCheckOut"] }}</span
            >
            <ng-template
              class="speedoMeter__content__checkOut__content__value__template"
              #changeCheckOut
            >
              <span
                class="speedoMeter__content__checkOut__content__value__template__edit"
              >
                <mat-form-field
                  class="speedoMeter__content__checkOut__content__value__template__edit__form"
                >
                  <input
                    matInput
                    type="text"
                    id="edit-checkOut-value"
                    formControlName="correctedCheckOut"
                    class="speedoMeter__content__checkOut__content__value__template__edit__form__input"
                    [value]="validationForm.value['correctedCheckOut']"
                    autofocus
                    autocomplete="off"
                  />
                </mat-form-field>
              </span>
            </ng-template>
            <span
              class="row no-gutters speedoMeter__content__checkOut__content__value__image"
              ><i
                [ngClass]="
                  editCheckOut == true ? 'fa fa-check' : 'fa fa-pencil'
                "
                class="speedoMeter__content__checkOut__content__value__image__icon"
                aria-hidden="true"
                (click)="isIconDisabled ? null : validateCheckIn()"
                [class.disabled]="isIconDisabled"
              ></i
            ></span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div *ngIf="trip" class="row no-gutters speedoMeter__footer">
      <div class="col-6 speedoMeter__footer__content">
        <span class="heading">Km Travelled:</span>
        <span
          class="speedoMeter__footer__content-strike"
          *ngIf="
            trip.odoMeterKM !=
            validationForm.value['correctedCheckOut'] -
              validationForm.value['correctedCheckIn']
          "
        >
          {{ trip.odoMeterKM }}
        </span>
        {{
          validationForm.value["correctedCheckOut"] -
            validationForm.value["correctedCheckIn"]
        }}
      </div>
      <div class="col-6 speedoMeter__footer__btns">
        <button
          class="speedoMeter__footer__btns__cancelBtn"
          (click)="closeDialog()"
          mat-stroked-button
        >
          Close
        </button>
        <button
          class="speedoMeter__footer__btns__confirmBtn"
          (click)="confirmSpeedoMeter()"
          id="submit-cash"
          [disabled]="!validationForm.valid || editCheckOut || editCheckIn"
          mat-raised-button
          color="primary"
        >
          Submit Cash
        </button>
      </div>
    </div>
  </div>
</form>
